/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-props-no-spreading */

import { Space } from "antd";
import React from "react";
import {
  getMenuParentElements,
  getParentMenuChildren,
} from "../../menuHelpers";
import { Logo } from "../Logo/Logo";

const SideNav = (props) => {
  const { mcontact, sitemegamenucontact } = props;
  const [parentMenu] = getMenuParentElements(sitemegamenucontact);
  const { menuChildren } = getParentMenuChildren(
    sitemegamenucontact,
    parentMenu.ID,
  );
  return (
    <Space
      style={{ justifyContent: "space-between" }}
      size="large"
      direction="vertical"
    >
      <ul style={{ width: "100%" }}>
        <li className="highlight-item">{parentMenu.title}</li>
      </ul>
      {menuChildren && (
        <ul className="megamenu__contact_menu">
          {menuChildren.map((item) => (
            <li className="no-border">
              <a href={item.url}>{item.title}</a>
            </li>
          ))}
        </ul>
      )}

      <Space size="large" direction="vertical">
        <Logo />
        <div className="megamenu__contact">
          <div dangerouslySetInnerHTML={{ __html: mcontact }} />
        </div>
      </Space>
    </Space>
  );
};

export default SideNav;
